import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRegisterFormFields, IRegisterSubmitField } from "@models/Register";
import FormValidation from "@/utils/validate";
import { fieldName } from "@/constants/validationFieldName";
import { IDataResponse } from "@/datasource/services/interface/IDataResponse";
import { ILabInfo } from "@/models/Lab";
import { number } from "yup";

interface orderOwner {
  [key: string]: any;
  clinic: any;
  clinics: any;
  labPartner: any;
  productClass: any;
  reason: any;
  items: any;
  filter: any;
}

const initialState: orderOwner = {
  clinic: {id: null,  clinic_name: '', clinic_name_f: ''},
  clinics: [],
  labPartner: [],
  productClass: [],
  reason: [],
  items: [],
  filter: { type: '', month: '', year: '' }
};

export const statisticClinicSlice = createSlice({
  name: "statisticClinic",
  initialState,
  reducers: {

    setState(state, action: PayloadAction<any>) {
      const { data, field }: any = action.payload;
      state [ field as string ] = data
    },

    fetchs(state, action: PayloadAction<any>) {
      const { data, Clinic, LabPartner, ProductClass, Reason, filter }: any = action.payload;
        state.clinic = Clinic;
        state.labPartner = LabPartner;
        state.productClass = ProductClass;
        state.reason = Reason;
        state.filter = filter;
        state.items = data;
    },
  },
});

const authReducer = statisticClinicSlice.reducer;
const { fetchs, setState } = statisticClinicSlice.actions;
export { fetchs, setState, authReducer };
